import { useProgress } from '../lib/playerHooks'

type TimeRemainingProps = {
  updateInterval: number;
  showSeconds?: boolean;
}

export const TimeRemaining: React.FC<TimeRemainingProps> = ({ updateInterval }) => {
  const { milliseconds = 0, duration = 0 } = useProgress(updateInterval || 250)


  let s = Math.floor((duration - milliseconds) / 1000)
  let m = Math.floor(s / 60)
  s %= 60
  const h = Math.floor(m / 60)
  m %= 60

  let ts = '-'
  if (h > 0) ts += `${h.toString().padStart(2, '0')}:`
  ts += `${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`


  return (
    <div className="time-remaining">
      {ts}
    </div>
  )
}
